import React from 'react'
import type { AiChatDockLayout } from '@ai-chat-widget-contracts/contracts'
import AiChatButton from '@/modules/base/components/ai/chat/ai-chat-button'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import useWebSocketEvent, { EventTypes } from '@/modules/webSocket'
import type { AiChatWebSocketEventData } from '@/modules/webSocket/types'
import {
  addUnreadConversationId,
  getMessage,
  selectCurrentConversationId,
  selectPopperOpen,
  setConversationStatus,
  setPopperOpenState,
} from '@/redux/ducks/ai/chat'

interface AiChatEntryLegacyProps {
  onDockLayoutChange?: (layout: AiChatDockLayout) => void
  initialOpen?: boolean
}

const AiChatEntryLegacy: React.FC<AiChatEntryLegacyProps> = ({ initialOpen = false }) => {
  const dispatch = useAppDispatch()
  const popperOpen = useAppSelector(selectPopperOpen)
  const currentConversationId = useAppSelector(selectCurrentConversationId)
  const activeTenantUserId = useAppSelector(state => state.user.info.activeTenant?.tenantUserId)

  React.useEffect(() => {
    if (initialOpen) dispatch(setPopperOpenState(true))
  }, [dispatch, initialOpen])

  useWebSocketEvent(EventTypes.AI_CHAT_RESPONSE, (event: AiChatWebSocketEventData) => {
    const { conversationId, messageId, status, tenantUserId } = event.data || {}
    if (conversationId && messageId && activeTenantUserId && activeTenantUserId === tenantUserId) {
      dispatch(setConversationStatus({ conversationId, status }))
      dispatch(getMessage({ messageId, conversationId }))
    }
    if (currentConversationId !== conversationId || !popperOpen) {
      dispatch(addUnreadConversationId(conversationId))
    }
  })

  return <AiChatButton />
}

export default AiChatEntryLegacy
